// Configuração da API
export const API_CONFIG = {
  // Resolver URL base sem hardcode de domínio/IP
  getBaseURL: () => {
    // Usar variável de ambiente se disponível
    if (import.meta.env.VITE_API_URL) {
      return import.meta.env.VITE_API_URL;
    }

    // Em desenvolvimento, priorizar proxy do Vite
    if (import.meta.env.DEV) {
      return '/api';
    }

    // Em produção com HTTPS, usar HTTPS no mesmo host
    if (window.location.protocol === 'https:') {
      return `${window.location.protocol}//${window.location.hostname}/api`;
    }

    // Fallback HTTP mantendo host atual
    return `${window.location.protocol}//${window.location.hostname}:3000/api`;
  },
  
  // URL do WebSocket
  getWebSocketURL: () => {
    // Usar variável de ambiente se disponível
    if (import.meta.env.VITE_WS_URL) {
      return import.meta.env.VITE_WS_URL;
    }
    
    // Em desenvolvimento, usar socket direto no backend local
    if (import.meta.env.DEV) {
      const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      return `${wsProtocol}//${window.location.hostname}:3000`;
    }

    // Se não houver variável, tentar derivar da URL da API
    const apiURL = API_CONFIG.getBaseURL();
    
    // Se a API URL contém /api, remover e usar como base
    if (apiURL.includes('/api')) {
      return apiURL.replace('/api', '').replace('http://', 'ws://').replace('https://', 'wss://');
    }
    
    // Fallback: usar o mesmo hostname da página
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const hostname = window.location.hostname;
    
    return `${protocol}//${hostname}`;
  }
}

export default API_CONFIG




